import { render } from "./ClinicPaymentHistoryTab.vue?vue&type=template&id=64a1c79e&scoped=true"
import script from "./ClinicPaymentHistoryTab.vue?vue&type=script&lang=js"
export * from "./ClinicPaymentHistoryTab.vue?vue&type=script&lang=js"

import "./ClinicPaymentHistoryTab.vue?vue&type=style&index=0&id=64a1c79e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64a1c79e"]])

export default __exports__